import { MachinesListDataTypes } from "@common/types/machines-list-types";
import apiUseCases from "@src/cloud-connect/api";
import { postVPNAuthKeySupportSessionDto } from "@src/cloud-connect/api/vpn-manager/vpn-post-generate-auth-key-support-session";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";

export const postVPNAuthKeySupportSessionUseCase = async (
  payload: postVPNAuthKeySupportSessionDto,
): Promise<{
  success: boolean;
  data?: MachinesListDataTypes;
  error?: string;
}> => {
  try {
    const response = await apiUseCases.postVPNAuthKeySupportSession(payload);

    return {
      success: true,
      data: response,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(
        error,
        "Failed to generate support session auth key.",
      ).message,
    };
  }
};
